import * as wjcCore from '@mescius/wijmo';
import * as wjInput from '@mescius/wijmo.input';
import * as wjOlap from '@mescius/wijmo.olap';

declare var Stimulsoft: any;

'use strict';

import {ViewChild, Component, OnInit} from '@angular/core';
import {Store} from "@ngrx/store";

import {ToasterService} from "angular2-toaster";
import {ActivePromotionConfig} from "../config/active-promotion.config";
import {asOrientDate, DataService, isOrientDate} from "@cosbeni/database";
import {saveAs} from "file-saver";
import {LoadUserAction} from "../ngrx/actions/user.action";
import {StimulsoftFontService} from "../services/stimulsoft-font.service";

@Component({
    standalone: false,
    selector: 'cj-user-summary',
    templateUrl: 'summary.component.html',
})

export class SummaryComponent implements OnInit {
    readonly: Boolean = true;
    @ViewChild('auctionComboBox') auctionComboBox: wjInput.ComboBox;
    auction: any = {};
    user: any = {};
    auctions: wjcCore.CollectionView = new wjcCore.CollectionView([]);
    items: wjcCore.CollectionView = new wjcCore.CollectionView([]);
    customerItems: wjcCore.CollectionView = new wjcCore.CollectionView([]);
    summaries: wjcCore.CollectionView = new wjcCore.CollectionView([]);
    mode: string = "view";
    pivot: wjOlap.PivotEngine;
    optionPlace: any[] = [];
    optionStatus: any[] = [];
    optionLane: any[] = [];
    selectAll: Boolean = false;
    viewer: any;
    viewerOptions: any;
    report: any;
    reportTemplate: any = {};

    constructor(public store: Store<any>, public dataService: DataService, public toasterService: ToasterService, private stimulsoftFontService: StimulsoftFontService) {
        this.store.dispatch(new LoadUserAction())
        this.store.select<any>("activePromotionFeature").subscribe((digitalAuction: any) => {
            if (wjcCore.isObject(digitalAuction.user) && digitalAuction.user.loaded) {
                this.user = digitalAuction.user.user;
                this.dataService.query({
                    sql: "SELECT auction FROM DA_Item WHERE (auctionResult = '落札' OR auctionResult = '売却済') AND ( buyer = " + this.user['@rid'] + " OR seller = " + this.user['@rid'] + " ) GROUP BY auction ORDER BY auction.eventDate DESC",
                    count: "SELECT auction FROM DA_Item WHERE (auctionResult = '落札' OR auctionResult = '売却済') AND ( buyer = " + this.user['@rid'] + " OR seller = " + this.user['@rid'] + " ) GROUP BY auction ORDER BY auction.eventDate DESC",
                    fetchPlan: "*:1",
                }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
                    if (wjcCore.isArray(data.results)) {
                        let auctions = [];
                        for (let item of data.results) {
                            item.auction.eventDate = asOrientDate(item.auction.eventDate);
                            item.auction.display = wjcCore.Globalize.formatDate(item.auction.eventDate, 'yyyy/MM/dd HH:mm:ss') + " " + item.auction.place + " " + item.auction.lane;
                            auctions.push(item.auction);
                        }
                        this.auctions.sourceCollection = auctions;
                        this.auctions.refresh();
                    }
                })
            }
        });
        this.dataService.query({
            sql: "SELECT FROM DA_Master WHERE category ='会場名' order by sort",
            count: "SELECT FROM DA_Master WHERE category ='会場名' order by sort",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            this.optionPlace = []
            if (wjcCore.isArray(data.results)) {
                for (let item of data.results) {
                    this.optionPlace.push(item.value);
                }
            }
        })
        this.dataService.query({
            sql: "SELECT FROM DA_Master WHERE category ='開催状態' order by sort",
            count: "SELECT FROM DA_Master WHERE category ='開催状態' order by sort",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            this.optionStatus = []
            if (wjcCore.isArray(data.results)) {
                for (let item of data.results) {
                    this.optionStatus.push(item.value);
                }
            }
        })
        this.dataService.query({
            sql: "SELECT FROM DA_Master WHERE category ='レーン' order by sort",
            count: "SELECT FROM DA_Master WHERE category ='レーン' order by sort",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            this.optionLane = []
            if (wjcCore.isArray(data.results)) {
                for (let item of data.results) {
                    this.optionLane.push(item.value);
                }
            }
        })
        this.mode = "view";
    }

    ngOnInit() {
        Stimulsoft.Base.StiLicense.Key = "6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHl26ZSMEMFmk3V4cVIW/z4aEPCZyhHy36IUIO31u64kPjupS5" +
            "RJ4Kkjh5zA8Js69gML1a/uLIe1uPsavO7G5SbuLvcEW0DcE58buMSZAh4scMesvQVrMM5AkiDUBomhUQfwCMrOWHM9" +
            "61Nb0khu5OVxh450w7X/qNMLW/Ncr+Djtsa1cbZzEQ4r7VkoHy7uZEPVVX9G3Qqtt/dB0cY62D4SY5Zal1nD/bV66S" +
            "3ok4BE+uUYDR5LQ+Yr1dtr+aM/BJUdeMdY6UGOaMthyAGzcyJ1CfV+9AQNrprnDoMQLK83sxIpn5aTSX/p/LNdTCZa" +
            "gpBGH4fp2hjcWVrAsVgkNVsL9zaA0v83O3CtoSlmJLK7M7IAmtsV3fyy3LRo6PlMmBmsPJMbsfQdIj9krxN3Hx9IEQ" +
            "QpIyo+/vGqtsCpDAFfQAmcv6UfTYw0j3XWdoiRQWNBhOjx1jRZwogSJ0wzdVnqa78HySzEfTFNpyWyiPFl7WBxTNnB" +
            "wAVazg9gu7dVCbvUJJA+BRdINej8KErdRgfy";
        // フォント/ローカライズは StimulsoftFontService が 1 回だけ非同期登録する (ira issue #151 と同対応)
        this.stimulsoftFontService.ensureLoaded();
        this.viewerOptions = new Stimulsoft.Viewer.StiViewerOptions();
        this.viewerOptions.appearance.scrollbarsMode = false;
        this.viewer = new Stimulsoft.Viewer.StiViewer(this.viewer, 'StiViewer', false);
        this.report = new Stimulsoft.Report.StiReport();
    }

    onAuctionChanged(): void {
        if (this.auction != this.auctionComboBox.selectedValue) {
            this.auction = this.auctionComboBox.selectedValue;
            if (wjcCore.isObject(this.auction) && wjcCore.isDate(this.auction.eventDate)) {
                this.dataService.query({
                    sql: "SELECT FROM DA_Item WHERE (auctionResult = '落札' OR auctionResult = '売却済')  AND auction = " + this.auction['@rid'] + " AND ( buyer = " + this.user['@rid'] + " OR seller = " + this.user['@rid'] + " ) ORDER BY sort,id",
                    count: "SELECT FROM DA_Item WHERE (auctionResult = '落札' OR auctionResult = '売却済')  AND auction = " + this.auction['@rid'] + " AND ( buyer = " + this.user['@rid'] + " OR seller = " + this.user['@rid'] + " ) ORDER BY sort,id",
                    fetchPlan: "*:1",
                }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
                    if (wjcCore.isArray(data.results)) {
                        for (let item of data.results) {
                            if (isOrientDate(item.auction.eventDate)) {
                                item.auction.eventDate = asOrientDate(item.auction.eventDate);
                            }
                        }
                        this.customerItems.sourceCollection = data.results;
                        this.calculateTotalAll();
                        this.generatePDF("売買台帳");
                    }
                })
            }
        }
    }

    calculateTotalAll() {
        let totalAll = {};
        for (let item of this.customerItems.sourceCollection) {
            if (!totalAll.hasOwnProperty(item.seller['@rid'])) {
                totalAll[item.seller['@rid']] = {
                    'customer': item.seller,
                    'summary': {}
                }
            }
            let sellerSummary = totalAll[item.seller['@rid']]['summary'];
            let sellerPercentage = item.sellerCharge * 100;
            let sellerField = "売" + sellerPercentage + "%";
            if (item.quantity < 0) {
                sellerField = "売返";
            }
            if (sellerSummary.hasOwnProperty(sellerField)) {
                sellerSummary[sellerField]['金額'] = sellerSummary[sellerField]['金額'] + item.quantity * item.auctionPrice * -1;
            } else {
                if (item.quantity < 0) {
                    sellerSummary[sellerField] = {
                        '掛率': item.buyerCharge * 100,
                        '金額': item.quantity * item.auctionPrice * -1
                    }
                } else {
                    sellerSummary[sellerField] = {
                        '掛率': item.sellerCharge * 100,
                        '金額': item.quantity * item.auctionPrice * -1
                    }
                }
            }
            if (item.quantity > 0 && item.sellerCharge > 0 && this.auction.entranceFee > 0) {
                sellerSummary['参加費'] = {
                    '掛率': 0,
                    '金額': this.auction.entranceFee
                }
                if (item.seller.hasOwnProperty('noFee') && item.seller.noFee) {
                    delete sellerSummary['参加費'];
                }
            }
            if (!totalAll.hasOwnProperty(item.buyer['@rid'])) {
                totalAll[item.buyer['@rid']] = {
                    'customer': item.buyer,
                    'summary': {}
                }
            }
            let buyerSummary = totalAll[item.buyer['@rid']]['summary'];
            let buyerPercentage = item.buyerCharge * 100;
            let buyerField = "買" + buyerPercentage + "%";
            if (item.quantity < 0) {
                buyerField = "買返";
            }
            if (buyerSummary.hasOwnProperty(buyerField)) {
                buyerSummary[buyerField]['金額'] = buyerSummary[buyerField]['金額'] + item.quantity * item.auctionPrice;
            } else {
                if (item.quantity < 0) {
                    buyerSummary[buyerField] = {
                        '掛率': item.buyerCharge * -100,
                        '金額': item.quantity * item.auctionPrice
                    }
                } else {
                    buyerSummary[buyerField] = {
                        '掛率': item.buyerCharge * 100,
                        '金額': item.quantity * item.auctionPrice
                    }
                }
            }
            if (item.quantity > 0 && item.buyerCharge > 0 && this.auction.entranceFee > 0) {
                buyerSummary['参加費'] = {
                    '掛率': 0,
                    '金額': this.auction.entranceFee
                }
                if (item.buyer.hasOwnProperty('noFee') && item.buyer.noFee) {
                    delete buyerSummary['参加費'];
                }
            }
            let summaries = [];
            Object.entries(totalAll).forEach(([key]) => {
                let customer = totalAll[key].customer;
                let summary = totalAll[key].summary;
                Object.entries(summary).forEach(([k]) => {
                    let v = summary[k];
                    v['顧客'] = customer;
                    v['顧客ID'] = customer.name;
                    v['顧客名'] = customer.memberName;
                    v['売買種類'] = k;
                    if (v['売買種類'].indexOf('売') > -1) {
                        v['相手'] = '買方'
                        if (v['売買種類'].indexOf('売返') == -1 && v['金額'] > 0) {
                            v['歩銭'] = Math.floor(v['金額'] * -1 * v['掛率'] / 100)
                        } else {
                            v['歩銭'] = Math.floor(Math.abs(v['金額']) * v['掛率'] / 100)
                        }

                    } else {
                        v['相手'] = '売方';
                        if (v['売買種類'].indexOf('買返') == -1 && v['金額'] < 0) {
                            v['歩銭'] = Math.floor(v['金額'] * v['掛率'] / 100)
                        } else {
                            v['歩銭'] = Math.floor(Math.abs(v['金額']) * v['掛率'] / 100)
                        }
                    }
                    v['消費税'] = Math.floor(v['歩銭'] * this.auction.taxPercentage)
                    v['合計'] = v['金額'] + v['歩銭'] + v['消費税']
                    summaries.push(v);
                });
            });
            this.summaries.sourceCollection = summaries;
            this.summaries.refresh();
        }
    }

    generatePDF(name) {
        if (this.mode == "view") {
            if (this.reportTemplate.hasOwnProperty("name") && this.reportTemplate.name == name) {
                this.exportPDF(name + wjcCore.Globalize.formatDate(this.auction.eventDate, 'yyyyMMdd') + this.auction.lane);
            } else {
                this.dataService.query({
                    sql: "SELECT FROM DA_Report WHERE name ='" + name + "'",
                    count: "SELECT FROM DA_Report WHERE name ='" + name + "'",
                    fetchPlan: "*:1",
                }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
                    if (wjcCore.isArray(data.results) && data.results.length == 1) {
                        this.reportTemplate = data.results[0];
                        this.exportPDF(name + wjcCore.Globalize.formatDate(this.auction.eventDate, 'yyyyMMdd') + this.auction.lane);
                    }
                })
            }
        }
    }

    async exportPDF(name) {
        await this.stimulsoftFontService.ensureLoaded();
        let r = (JSON.parse(JSON.stringify(this.reportTemplate.content)));
        delete r['@type'];
        delete r['@version'];
        this.report = new Stimulsoft.Report.StiReport();
        this.report.load(r);
        this.report.dictionary.databases.clear();
        let data: any = {};
        data.auction = {
            '日付': wjcCore.Globalize.formatDate(this.auction.eventDate, 'yyyy/MM/dd'),
            '合計金額': 0
        };
        data.summary = [];
        for (let summary of this.summaries.items) {
            if (summary['顧客']['@rid'] == this.user['@rid']) {
                data.summary.push(summary);
            }
        }
        data.detail = [];
        for (let item of this.customerItems.items) {
            let detail = {ID: item.id}
            if (item.seller['@rid'] == this.user['@rid']) {
                let sellerPercentage = item.sellerCharge * 100;
                let field = "売" + sellerPercentage + "%";
                if (item.quantity < 0) {
                    field = "売返"
                }
                detail['売買種類'] = field;
                detail['金額'] = Math.abs(item.quantity) * item.auctionPrice;
                if (Math.abs(item['個数']) > 1)
                    detail['付加情報'] = Math.abs(item.quantity) + " x " + item.auctionPrice;
                detail['商品名'] = item.name;
                detail['相手'] = item.buyer.memberName;
            }
            if (item.buyer['@rid'] == this.user['@rid']) {
                let buyerPercentage = item.buyerCharge * 100;
                let field = "買" + buyerPercentage + "%";
                if (item.quantity < 0) {
                    field = "買返"
                }
                detail['売買種類'] = field
                detail['金額'] = Math.abs(item.quantity) * item.auctionPrice;
                if (Math.abs(item['個数']) > 1)
                    detail['付加情報'] = Math.abs(item.quantity) + " x " + item.auctionPrice;
                detail['商品名'] = item.name
                detail['相手'] = item.seller.memberName;
            }
            if (detail['金額'] > 0)
                data.detail.push(detail);
        }
        data.customer = {
            ID: this.user.name,
            "名称": this.user.memberName
        }
        for (let summary of data.summary) {
            data.auction['合計金額'] = data.auction['合計金額'] + summary['合計'];
        }
        let dataSet = new Stimulsoft.System.Data.DataSet("data");
        dataSet.readJson(data);
        this.report.regData(dataSet.dataSetName, "data", dataSet);
        var report = this.report;
        this.viewer.report = this.report;
        var viewer = this.viewer;
        report.renderAsync(function () {
            viewer.renderHtml("viewerContent");
        }, false);
    }

    downloadPDF(): void {
        var pdfSettings = new Stimulsoft.Report.Export.StiPdfExportSettings();
        pdfSettings.embeddedFonts = true;
        var pdfService = new Stimulsoft.Report.Export.StiPdfExportService();
        var stream = new Stimulsoft.System.IO.MemoryStream();
        let name = "売買台帳" + wjcCore.Globalize.formatDate(this.auction.eventDate, 'yyyyMMdd') + this.auction.lane;
        pdfService.exportToAsync(function () {
            var data = stream.toArray();
            var blob = new Blob([new Uint8Array(data)], {type: "application/pdf"});
            saveAs(blob, name + ".pdf");
        }, this.report, stream, pdfSettings);
    }

    refresh(grid: string): void {
        this[grid].invalidate();
    }

}

